import { Box, Button } from "@chakra-ui/react";
import React from "react";
import { PlayIcon } from "./playicon";
import { useTranslation } from "react-i18next";
const ContinueLearning: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <Box
      width="178px"
      height="36px"
      borderWidth="1px"
      display="flex"
      alignItems="center"
    >
      <Button
        fontFamily="Poppins"
        fontSize="14px"
        fontWeight="500"
        height="100%"
        bg="#1819B4"
      >
        <PlayIcon boxSize={3} m="1" />
        {t("certificateSection.continueLearning")}
      </Button>
    </Box>
  );
};

export default ContinueLearning;
